import { Routes } from '@angular/router';
import { LoginComponent } from './presentation/pages/login';
import { InicioComponent } from './presentation/pages/movil/inicio';
import { NuevoProveedorComponent } from './presentation/pages/movil/nuevo-proveedor';
import { CapturaProductoComponent } from './presentation/pages/movil/captura-producto';
import { ProtegidoComponent } from './presentation/layout/protegido';
import { ModuleGatewayComponent } from './presentation/layout/module-gateway/module-gateway';
import { DashboardComponent } from './presentation/pages/dashboard';

/**
 * '' es el gateway de módulos (Jamar → Feria / Calidad), público, SIN guard —
 * debe verse antes de cualquier login (2026-10-12, ver
 * Plan-Accion-Module-Gateway-Calidad.md). Cada módulo tiene su propio login
 * público (`/login` para Feria, sin tocar; `/calidad/login` nuevo para
 * Calidad) y sus rutas reales protegidas por `ProtegidoComponent`, igual que
 * siempre.
 */
export const routes: Routes = [
  { path: '', component: ModuleGatewayComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'calidad/login',
    loadComponent: () => import('./presentation/pages/calidad/login-calidad/login-calidad').then((m) => m.LoginCalidadComponent),
  },
  {
    path: '',
    component: ProtegidoComponent,
    children: [
      { path: 'movil', component: InicioComponent },
      { path: 'movil/proveedor', component: NuevoProveedorComponent },
      { path: 'movil/captura', component: CapturaProductoComponent },
      { path: 'dashboard', component: DashboardComponent },
      // Acceso directo al tablero desde el celular (boton "Ver tablero" en
      // movil/inicio.html) — el propio DashboardComponent ya trae su
      // responsive para pantalla angosta.
      { path: 'dashboard-movil', component: DashboardComponent },
      {
        path: 'calidad',
        loadComponent: () => import('./presentation/pages/calidad/calidad').then((m) => m.CalidadComponent),
      },
    ],
  },
];
